import transitionPage from "@/components/transitionPage/index";

export default {
  name: "email-verification",
  components: { transitionPage },
  props: [],
  data() {
    return { baseURL: process.env.VUE_APP_PUBLIC_BASE_URL };
  },
  computed: {},
  mounted() {},
  methods: {}
};
